import { createRouteContext } from '@/providers';
import { ModelContributionRoute } from '@/types/routes';

const {
    RouteProvider: ModelContributionRouteProvider,
    useRouteContext: useModelContributionRoute,
} = createRouteContext<ModelContributionRoute>();

export { ModelContributionRouteProvider, useModelContributionRoute };
